







import Vue from "vue";
import { UserI } from "vue/types/vue";
export default Vue.extend({
  props: {
    user: {
      type: Object as () => UserI,
      default: {} as () => UserI
    }
  },
  methods: {
    deleteUser: async function(): Promise<void> {
      this.$emit('delete-user');
    }
  }
});
